import { getApiBaseUrl } from "../api/client";

function apiOrigin() {
  const base = String(getApiBaseUrl() || "").trim();
  if (!base || base.startsWith("/")) {
    return typeof window !== "undefined" ? window.location.origin : "";
  }

  try {
    return new URL(base).origin;
  } catch {
    return "";
  }
}

export function resolveLandingAssetUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^(https?:|data:|blob:)/i.test(raw)) return raw;

  const normalized = raw.startsWith("files/") ? `/${raw}` : raw;
  if (normalized.startsWith("/files/")) {
    return `${apiOrigin()}${normalized}`;
  }

  return normalized;
}

export function assetValueFromResponse(response) {
  const asset = response?.asset || {};
  if (asset.publicPath) return asset.publicPath;
  if (asset.path) return `/files/${String(asset.path).replace(/^\/+/, "")}`;
  return asset.url || "";
}

export function isManagedLandingAsset(value) {
  const raw = String(value || "").trim();
  if (!raw) return false;

  try {
    const pathname = /^https?:\/\//i.test(raw) ? new URL(raw).pathname : raw;
    return /(?:^|\/)files\/projects\/[^/]+\/landing\//i.test(pathname);
  } catch {
    return false;
  }
}

export function fileLabelFromAsset(value) {
  const raw = String(value || "").split(/[?#]/, 1)[0];
  const parts = raw.split("/").filter(Boolean);
  return parts[parts.length - 1] || "Archivo cargado";
}
